import type { DocumentDraftStore } from './documentDraftStore';

import { buildFaxHeaderMarkdown, DEFAULT_FAX_TITLE } from './faxDraftTemplate';

/** Matches FAX_DRAFTS_SHELF_KEY in lotushealth.faxes. */
export const FAX_DRAFTS_SHELF_KEY = 'fax-drafts-v1';

export const FAX_DRAFT_STORE: DocumentDraftStore = {
  shelfKey: FAX_DRAFTS_SHELF_KEY,
  kind: 'fax-drafts',
  schemaVersion: 7,
  buildNewDraftMarkdown: (header) =>
    `${buildFaxHeaderMarkdown({ ...header, title: DEFAULT_FAX_TITLE })}\n\n## Clinician Overview\n\n`,
};
